import { connect } from 'react-redux'
import { withPropsOnChange, withHandlers, compose } from 'recompose'
import { toggleCurrentBids } from '../layout'
import { getWinningItemIds, getOutbidItemIds } from './index'
import { t } from '../../core/i18n'

const mapStateToProps = state => {
  return {
    outbidItemBids: getOutbidItemIds(state),
    winningItemBids: getWinningItemIds(state)
  }
}

const mapDispatchToProps = { toggleCurrentBids }

const withCurrentBidsData = connect(mapStateToProps, mapDispatchToProps)

const withTranslations = withPropsOnChange([], props => ({
  title: t('currentBids.title')
}))

const withCloseHandler = withHandlers({
  onClose: props => e => {
    e.preventDefault()
    props.toggleCurrentBids()
  }
})

const decorator = compose(
  withTranslations,
  withCurrentBidsData,
  withCloseHandler
)

export default decorator



// WEBPACK FOOTER //
// ./src/services/bid/current-bids.js